// JsFromRoutes CacheKey bd2aead5e3a7dc89d0d3f1962f5a3649
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  fileUploads: /* #__PURE__ */ definePathHelper('post', '/members/documents/file_uploads'),
  index: /* #__PURE__ */ definePathHelper('get', '/members/documents'),
}
